import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  TextField,
  CircularProgress
} from "@material-ui/core";
import WrenchIcon from "@material-ui/icons/Build";

import {
  selectSubmission,
  clearSelectedSubmission
} from "../../actions/selectActions";
import {
  approveProcess,
  removeProcess,
  approveReference,
  removeReference,
  deleteComment,
  changeSubmission
} from "../../actions/adminActions";
import { closeApprovalModal } from "../../actions/modalActions";
import { getMetadata, displayError } from "../../actions/processActions";

import "../../styles/processList.scss";

class ApprovalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeApprovalModal();
      this.props.clearSelectedSubmission();
    }
  };

  handleSubmit = async () => {
    const metadata = await getMetadata(
      this.props.selectedSubmission.submission.reference.doi
    );

    if (!metadata) {
      this.props.displayError("Could not retrieve metadata for provided DOI");
      return;
    }

    const appendedSubmission = {
      ...this.props.selectedSubmission.submission,
      ...metadata
    };

    switch (this.props.selectedSubmission.type) {
      case "process": {
        this.props.approveProcess(appendedSubmission, this.props.adminPassword);
        break;
      }
      case "reference": {
        this.props.approveReference(
          appendedSubmission,
          this.props.adminPassword
        );
        break;
      }
      default: {
        break;
      }
    }
    this.props.clearSelectedSubmission();
  };

  handleRemove = () => {
    switch (this.props.selectedSubmission.type) {
      case "process": {
        this.props.removeProcess(
          this.props.selectedSubmission.submission,
          this.props.adminPassword
        );
        break;
      }
      case "reference": {
        this.props.removeReference(
          this.props.selectedSubmission.submission,
          this.props.adminPassword
        );
        break;
      }
      default: {
        break;
      }
    }
    this.props.clearSelectedSubmission();
  };

  handleChangeFormData = (key, value) => {
    this.props.changeSubmission(key, value);
  };

  getTitle = () => {
    if (this.props.submissionsLoading) {
      return "Loading submissions...";
    }

    if (!this.props.selectedSubmission.submission) {
      return "Select a submission to view";
    }
    const { submission, type } = this.props.selectedSubmission;

    switch (type) {
      case "reference": {
        return `Reviewing reference for the ALD of ${
          submission.material
        } using ${submission.reactants[0]} and ${submission.reactants[1]}`;
      }
      case "process": {
        return "Reviewing process";
      }
      default: {
        return "Error, no submission type";
      }
    }
  };

  getModalContent = () => {
    if (this.props.submissionsLoading) {
      return <CircularProgress />;
    }

    if (!this.props.selectedSubmission.type) {
      return (
        <>
          {this.props.processSubmissions.length === 0 &&
            this.props.referenceSubmissions.length === 0 &&
            this.props.comments.length === 0 &&
            "No submissions or comments to review"}
          {this.props.processSubmissions.length !== 0 && (
            <table className="processList--table">
              <tbody>
                <tr>
                  <td>Processes</td>
                </tr>
                <tr className="header">
                  <td>Review</td>
                  <td>Material</td>
                  <td>Reactant A</td>
                  <td>Reactant B</td>
                  <td>Reactant C</td>
                  <td>Reactant D</td>
                  <td>Reference</td>
                </tr>

                {this.props.processSubmissions.map(submission => {
                  return (
                    <tr>
                      <td>
                        <WrenchIcon
                          onClick={() => {
                            this.props.selectSubmission(submission, "process");
                          }}
                        />
                      </td>
                      <td>{submission.material}</td>
                      <td>{submission.reactants[0]}</td>
                      <td>{submission.reactants[1]}</td>
                      <td>{submission.reactants[2]}</td>
                      <td>{submission.reactants[3]}</td>
                      <td>
                        <a
                          href={"https://doi.org/" + submission.reference.doi}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {submission.reference.doi}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {this.props.referenceSubmissions.length !== 0 && (
            <table className="processList--table">
              <tbody>
                <tr>
                  <td>References</td>
                </tr>
                <tr className="header">
                  <td>Review</td>
                  <td>Material</td>
                  <td>Reactant A</td>
                  <td>Reactant B</td>
                  <td>Reactant C</td>
                  <td>Reactant D</td>
                  <td>Reference</td>
                </tr>
                {this.props.referenceSubmissions.map(submission => {
                  return (
                    <tr>
                      <td>
                        <WrenchIcon
                          onClick={() => {
                            this.props.selectSubmission(
                              submission,
                              "reference"
                            );
                          }}
                        />
                      </td>
                      <td>{submission.material}</td>
                      <td>{submission.reactants[0]}</td>
                      <td>{submission.reactants[1]}</td>
                      <td>{submission.reactants[2]}</td>
                      <td>{submission.reactants[3]}</td>
                      <td>
                        <a
                          href={"https://doi.org/" + submission.reference.doi}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {submission.reference.doi}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {this.props.comments.length !== 0 && (
            <table className="processList--table">
              <tbody>
                <tr>
                  <td>Comments</td>
                </tr>
                <tr className="header">
                  <td>Name</td>
                  <td>Comment</td>
                </tr>
                {this.props.comments.map(comment => {
                  return (
                    <tr>
                      <td>{comment.comment_name}</td>
                      <td>{comment.comment_text}</td>
                      <td>
                        <Button
                          color="secondary"
                          onClick={() =>
                            this.props.deleteComment(
                              comment.comment_id,
                              this.props.adminPassword
                            )
                          }
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <br />
          Visitors to the site: {this.props.visitors}
        </>
      );
    }
    const { type } = this.props.selectedSubmission;

    switch (type) {
      case "reference": {
        return (
          <>
            <TextField
              margin="dense"
              label="Reference"
              value={this.props.selectedSubmission.submission.reference.doi}
              onChange={event =>
                this.handleChangeFormData("reference.doi", event.target.value)
              }
            />
          </>
        );
      }
      case "process": {
        console.log(this.props.selectedSubmission);
        return (
          <>
            <TextField
              margin="dense"
              label="Material"
              value={this.props.selectedSubmission.submission.material}
              onChange={event =>
                this.handleChangeFormData("material", event.target.value)
              }
            />
            <br />
            <TextField
              margin="dense"
              label="Reactant A"
              value={this.props.selectedSubmission.submission.reactants[0]}
              onChange={event =>
                this.handleChangeFormData("reactants[0]", event.target.value)
              }
            />
            <TextField
              margin="dense"
              label="Reactant B"
              value={this.props.selectedSubmission.submission.reactants[1]}
              onChange={event =>
                this.handleChangeFormData("reactants[1]", event.target.value)
              }
            />
            <br />
            <TextField
              margin="dense"
              label="Reactant C (optional)"
              value={this.props.selectedSubmission.submission.reactants[2]}
              onChange={event =>
                this.handleChangeFormData("reactants[2]", event.target.value)
              }
            />
            <TextField
              margin="dense"
              label="Reactant D (optional)"
              value={this.props.selectedSubmission.submission.reactants[3]}
              onChange={event =>
                this.handleChangeFormData("reactants[3]", event.target.value)
              }
            />
            <br />
            <TextField
              margin="dense"
              label="Reference (DOI)"
              value={this.props.selectedSubmission.submission.reference.doi}
              fullWidth
              onChange={event =>
                this.handleChangeFormData("reference.doi", event.target.value)
              }
            />
            <br />
            <TextField
              margin="dense"
              label="Note"
              value={this.props.selectedSubmission.submission.note}
              multiLine
              fullWidth
              onChange={event =>
                this.handleChangeFormData("note", event.target.value)
              }
            />
          </>
        );
      }
      default: {
        return "Error, no submission type";
      }
    }
  };

  render() {
    const actions = [];

    if (this.props.selectedSubmission.submission) {
      actions.push(
        <Button color="secondary" onClick={this.props.clearSelectedSubmission}>
          Cancel
        </Button>,
        <Button color="primary" keyboardFocused onClick={this.handleRemove}>
          Remove
        </Button>,
        <Button color="primary" keyboardFocused onClick={this.handleSubmit}>
          Approve
        </Button>
      );
    } else {
      actions.push(
        <Button color="secondary" onClick={this.handleClose}>
          Cancel
        </Button>
      );
    }

    return (
      <>
        <Dialog
          open={this.props.isOpen}
          onClose={this.handleClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>{this.getTitle()}</DialogTitle>
          <DialogContent>
            {this.props.isOpen && this.getModalContent()}
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    submissionsLoading: state.admin.submissionsLoading,
    processSubmissions: state.admin.processSubmissions,
    referenceSubmissions: state.admin.referenceSubmissions,
    selectedSubmission: state.selected.submission,
    isOpen: state.modal.approvalModalIsOpen,
    adminPassword: state.admin.password,
    comments: state.admin.comments,
    modalOpenTime: state.modal.modalOpenTime,
    visitors: state.admin.visitors
  };
}

export default connect(
  mapStateToProps,
  {
    closeApprovalModal,
    selectSubmission,
    clearSelectedSubmission,
    approveProcess,
    removeProcess,
    approveReference,
    removeReference,
    deleteComment,
    displayError,
    changeSubmission
  }
)(ApprovalModal);
